import { render, staticRenderFns } from "./KPIInclusionNew.vue?vue&type=template&id=8687ceba"
import script from "./KPIInclusionNew.vue?vue&type=script&lang=js"
export * from "./KPIInclusionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports